import { Button, Typography } from '@breetometer/components';
import { TrashIcon } from 'BreetAssets';

import type { IBeneficiaryCard } from '../BeneficiaryCard.helpers';

const DeleteCard = ({ name, bankName, accountNumber, onClick }: IBeneficiaryCard) => (
	<Button
		variant='native'
		className='beneficiarydelete border-dark-navy'
		onClick={onClick}
		type='button'
	>
		<div className='beneficiarydelete_details'>
			<Typography className='color-primary-50'>{name}</Typography>
			<Typography
				as='h5'
				className='color-neutral-50'
			>
				{accountNumber}
			</Typography>
			<Typography
				as='h6'
				className='color-neutral-50'
			>
				{bankName}
			</Typography>
		</div>
		<div className='beneficiarydelete_deletecta cursor_pointer'>
			<TrashIcon
				variant='secondary'
				className='cursor_pointer'
				focusable
			/>
			<Typography as='p'>Delete</Typography>
		</div>
	</Button>
);

export default DeleteCard;
